import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadsPartnersComponent } from './components/leads-partners-at-a-glance/leads-partners.component';
import { LeadsPartnersTransitionComponent } from './components/leads-partners-transition/leads-partners-transition.component';
import { LeadsPartnersInsightsComponent } from './components/leads-partners-insights/leads-partners-insights.component';
import { LeadsPartnersReportsComponent } from './components/leads-partners-reports/leads-partners-reports.component';
import { LeadsPartnersUpgradeComponent } from './components/leads-partners-upgrade/leads-partners-upgrade.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { RankingsByPartnerComponent } from './components/rankings-by-partner/rankings-by-partner.component';

const leadsPartnersRoutes: Routes = [
    { path: '', component: LeadsPartnersTransitionComponent },
    {
        path: 'at-a-glance',
        component: LeadsPartnersComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights',
        component: LeadsPartnersInsightsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'reports',
        component: LeadsPartnersReportsComponent,
        canActivate: [AuthGuardService],
    },
    { path: 'upgrade', component: LeadsPartnersUpgradeComponent },
    {
        path: 'insights/rankings-by-partner',
        component: RankingsByPartnerComponent,
        canActivate: [AuthGuardService],
    },
];

@NgModule({
    imports: [RouterModule.forChild(leadsPartnersRoutes)],
    exports: [RouterModule],
})
export class LeadsPartnersRoutingModule {}
